module.exports = __webpack_public_path__ + "img/1645.81534477.gif";